// UI Reducer
import { createReducer, on } from '@ngrx/store';
import { UiState, initialUiState } from './ui.state';
import * as UiActions from './ui.actions';

export const uiReducer = createReducer(
  initialUiState,

  // Sidebar
  on(UiActions.toggleSidebar, (state) => ({
    ...state,
    sidebarCollapsed: !state.sidebarCollapsed,
  })),
  on(UiActions.collapseSidebar, (state) => ({
    ...state,
    sidebarCollapsed: true,
  })),
  on(UiActions.expandSidebar, (state) => ({
    ...state,
    sidebarCollapsed: false,
  })),
  on(UiActions.toggleMobileSidebar, (state) => ({
    ...state,
    sidebarMobileOpen: !state.sidebarMobileOpen,
  })),
  on(UiActions.closeMobileSidebar, (state) => ({
    ...state,
    sidebarMobileOpen: false,
  })),

  // Theme
  on(UiActions.setTheme, (state, { theme }) => ({
    ...state,
    theme,
  })),
  on(UiActions.toggleTheme, (state) => ({
    ...state,
    theme: state.theme === 'light' ? 'dark' : 'light',
  })),

  // Notifications
  on(UiActions.toggleNotificationsPanel, (state) => ({
    ...state,
    notificationsPanelOpen: !state.notificationsPanelOpen,
  })),
  on(UiActions.openNotificationsPanel, (state) => ({
    ...state,
    notificationsPanelOpen: true,
  })),
  on(UiActions.closeNotificationsPanel, (state) => ({
    ...state,
    notificationsPanelOpen: false,
  })),
  on(UiActions.setUnreadNotificationsCount, (state, { count }) => ({
    ...state,
    unreadNotificationsCount: count,
  })),
  on(UiActions.incrementUnreadNotifications, (state) => ({
    ...state,
    unreadNotificationsCount: state.unreadNotificationsCount + 1,
  })),
  on(UiActions.clearUnreadNotifications, (state) => ({
    ...state,
    unreadNotificationsCount: 0,
  })),

  // Modals
  on(UiActions.openModal, (state, { modalId, data }) => ({
    ...state,
    activeModal: modalId,
    modalData: data ?? null,
  })),
  on(UiActions.closeModal, (state) => ({
    ...state,
    activeModal: null,
    modalData: null,
  })),

  // Global Loading
  on(UiActions.showGlobalLoading, (state, { message }) => ({
    ...state,
    globalLoading: true,
    globalLoadingMessage: message ?? null,
  })),
  on(UiActions.hideGlobalLoading, (state) => ({
    ...state,
    globalLoading: false,
    globalLoadingMessage: null,
  })),

  // Breadcrumbs
  on(UiActions.setBreadcrumbs, (state, { breadcrumbs }) => ({
    ...state,
    breadcrumbs,
  })),
  on(UiActions.addBreadcrumb, (state, { breadcrumb }) => ({
    ...state,
    breadcrumbs: [...state.breadcrumbs, breadcrumb],
  })),
  on(UiActions.clearBreadcrumbs, (state) => ({
    ...state,
    breadcrumbs: [],
  }))
);
